export default __webpack_public_path__ + "static/banner-finance-most-reliable-cars-7a14de13dcfff5819ae8439ca0b35451.jpg";